import {
  STATUS_DISPLAY_NAMES,
  STATUS_ID_TO_SLUG_MAP,
  STATUS_SLUG_TO_ID_MAP,
} from "@nlc/shared-types";

/**
 * Get display name for a status slug
 * @param slug - The status slug
 * @returns The human-readable display name
 *
 * @example
 * getStatusDisplayName('processing_request') // 'Processing Request'
 * getStatusDisplayName('in_queue') // 'In Queue'
 */
export function getStatusDisplayName(slug: string): string {
  return STATUS_DISPLAY_NAMES[slug] || slug;
}

/**
 * Map status slug to database ID (for API calls)
 * @param slug - The status slug
 * @returns The corresponding database status ID
 *
 * Note: This is a temporary mapping until we fully migrate to slug-based APIs
 */
export function getStatusIdFromSlug(slug: string): number {
  return STATUS_SLUG_TO_ID_MAP[slug] || 0;
}

/**
 * Map status ID to slug (for reverse lookups)
 * @param statusId - The database status ID
 * @returns The corresponding status slug
 */
export function getSlugFromStatusId(statusId: number): string {
  return STATUS_ID_TO_SLUG_MAP[statusId] || "";
}

/**
 * Get status name by ID (for optimistic updates)
 * This matches the existing implementation in useUpdateRequestField
 * @param statusId - The status ID
 * @returns The human-readable status name
 */
export function getStatusNameById(statusId: number): string {
  const slug = STATUS_ID_TO_SLUG_MAP[statusId];

  return slug ? STATUS_DISPLAY_NAMES[slug] || "Unknown" : "Unknown";
}
